import React from 'react';
import './SectionHeadingStyles.css';
import Reveal from './Reveal';

const SectionHeading = ({ eyebrow, title, text }) => {
  return (
    <Reveal as="div" className="section-heading">
      {eyebrow && <p className="section-eyebrow">{eyebrow}</p>}
      <h2>{title}</h2>
      {text && <p className="section-text">{text}</p>}
    </Reveal>
  );
};

export default SectionHeading;
